import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Feedback from "./ViewJob/Feedback.jsx";
import axios from "axios";
// import { FeedbackSuccessAction } from "../../../Redux/action/FeedbackDataAction.js";
import { Button, Modal } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import { useCandidateById, useVendorById } from "../../../Hooks/useUserDetails.js";
import { useInterviewById } from "../../../Hooks/useInterview.js";
import { getInterviewById, InterviewComplete } from "../../../Services/interviewService.js"
import { CandidateProfile } from "../../../Redux/action/CandidateProfileAction.js";
import { VendorProfile } from "../../../Redux/action/VendorProfileAction.js";
import Loader from "../../Common/Loader/loader.js";

const baseUrl = process.env.REACT_APP_API_PATH;

const AssignedInterviewsInfo = () => {
  const { userResult } = useSelector((state) => state.Auth);
  const userIdData = userResult?.userid;;
  const candidateIdData = localStorage.getItem("candidateVendorId");
  const userInfo = useSelector((state) => state.Profile.result);
  const vendorIdData = userInfo?.vendorId;
  const location = useLocation();
  const interviewIDFromURL = location?.state?.dataToSend;
  const [receivedData, setReceivedData] = useState(null);
  const [reload, setReload] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [isInterviewComplete, setIsComplete] = useState(false);
  const [isComeDis, setIsComeDis] = useState(false); 
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const { data: detasd, isError } = useInterviewById(interviewIDFromURL);
  const { data: interviewerVendor, isLoading: isLoadingVendor } = useVendorById(receivedData?.interviewerVendorId);
  const { data: candidateVendor, isLoading: isLoadingVendorCandidate } = useVendorById(receivedData?.candidateVendorId, !!receivedData?.candidateVendorId);
  const { data: candidateDetails, isLoading: isLoadingCandidate } = useCandidateById(receivedData?.candidateId, !receivedData?.candidateVendorId);
  console.log("the data in inter view", interviewIDFromURL)
  useEffect(() => {
    setIsLoading(true);
    getInterviewById(interviewIDFromURL).then((res) => {
      setReceivedData(res)
      setIsLoading(false);
    });
  }, [interviewIDFromURL]);

  useEffect(() => {
    if (candidateIdData) {
      dispatch(CandidateProfile(userIdData));
      dispatch(VendorProfile(candidateIdData));
    }
  }, [candidateIdData]);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // "2024-11-14 11:56"
  const isJoinButtonEnabled = () => {
    const interviewDateStr = receivedData?.interviewDate;
    if (!interviewDateStr) return false;
    const interviewDate = new Date(interviewDateStr?.replace(" ", "T"));

    const joinTime = new Date(interviewDate.getTime() - 10 * 60 * 1000); // 10 minutes before interview
    return new Date() >= joinTime;
  };

  const isFeedbackButtonEnabled = () => {
    const interviewDateStr = receivedData?.interviewDate
    if (!receivedData?.interviewDate) return false;
    const interviewDate = new Date(interviewDateStr?.replace(" ", "T"));
    const feedTime = new Date(interviewDate.getTime() + 5 * 60 * 1000); // 5 minutes after interview
    return new Date() >= feedTime;
  };


  const handleCompleteInterview = () => {
    setIsComeDis(true);
    const data = {
      "interviewId": parseInt(receivedData?.interviewId),
      "isInterviewClosed": true
    }
    InterviewComplete(data).then((res) => {
      setIsComplete(false)
      setIsComeDis(false);
      // setReload(true)
      setIsLoading(true);
      getInterviewById(interviewIDFromURL).then((res) => {
        console.log("the data in inter view", res)
        setReceivedData(res)
        setIsLoading(false);
      });
    })
  }
  console.log(isLoading, "object new or id", isLoadingVendor, isLoadingVendorCandidate, isLoadingCandidate)

  if (isLoadingVendor || isLoadingVendorCandidate || isLoadingCandidate || isLoading) return <div style={{ height: "70vh", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <Loader />
  </div>

  return (
    <>
      <ToastContainer />
      <div style={location.pathname.includes('/admin/interview/interviews_info') ? { backgroundColor: 'rgb(246, 249, 255)', minHeight: '100vh' } : {}} className={location.pathname.includes('admin') ? 'mt-1' : "vj_wrapper"}>
        <div
          className="vj_container d-flex justify-content-between "
          style={location.pathname.includes('/admin/interview/interviews_info') ? { padding: '10px', width: '98%', margin: '0px auto' } : { margin: "35px 0px" }}
        >
          <div
            // className="vj_left "
            style={{
              minWidth: location.pathname.includes('/admin/interview/interviews_info') ? "100%" : "100%",
              padding: "5px",
              backgroundColor: 'white',
              boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div className="common_table_header">
              <p style={{ margin: "0px" }}>Interview Details</p>
            </div>
            <div className="line_divide"></div>

            <div style={location.pathname.includes('/admin/interview/interviews_info') ? { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 3, padding: '12px' } : { display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 3, padding: '12px' }}>
              <p className="">
                Interviewer Name:{""}
                <span className="text-secondary fw-normal">
                  {receivedData?.interviewerName}
                </span>{" "}
              </p>

              <p className="">
                Duration:{" "}
                <span className="text-secondary fw-normal">
                  {receivedData?.duration || "N/A"}
                </span>{" "}
              </p>
              <p className="">
                Interview Date:{" "}
                <span className="text-secondary fw-normal">
                  {
                    receivedData?.interviewDate.split(" ")[0].split("-")[2] + "-" +
                    receivedData?.interviewDate.split(" ")[0].split("-")[1] + "-" +
                    receivedData?.interviewDate.split(" ")[0].split("-")[0]
                    || "N/A"}
                </span>{" "}
              </p>
              <p className="">
                Interview Time:{" "}
                <span className="text-secondary fw-normal">
                  {receivedData?.interviewDate.split(" ")[1] || "N/A"}
                  {receivedData?.timeZone ? receivedData?.timeZone.split(" ")[0] : ""}
                </span>{" "}
              </p>
              {(receivedData?.candidateInterviewStatus !== null) && candidateIdData === "null" && (
                <p className="">
                  Interview Status:{" "}
                  <span className="text-secondary fw-normal">
                    {/* SELECT, REJECT, ONHOLD, PENDING, NEXT_ROUND */}
                    {(receivedData?.candidateInterviewStatus === "SELECT" ? "Selected" :
                      receivedData?.candidateInterviewStatus === "REJECT" ? "Rejected" :
                        receivedData?.candidateInterviewStatus === "ONHOLD" ? "On Hold" :
                          receivedData?.candidateInterviewStatus === "PENDING" ? "Pending" :
                            receivedData?.candidateInterviewStatus === "NEXT_ROUND" ? "Next Round" : receivedData?.candidateInterviewStatus
                    ) || receivedData?.candidateInterviewStatus}
                  </span>{" "}
                </p>
              )}
              {(receivedData?.rating !== null) && candidateIdData === "null" && (
                <p className="">
                  Score:{" "}
                  <span className="text-secondary fw-normal">
                    {receivedData?.rating || "N/A"}
                  </span>{" "}
                </p>
              )}
              <p className="">
                Interview Status:{" "}
                <span
                  className={` ${receivedData?.interviewStatus === "COMPLETED"
                    ? "textGreenForStatus"
                    : receivedData?.interviewStatus === "CANCELLED"
                      ? "textRedForStatus"
                      : "text-secondary fw-normal"
                    } `}
                >
                  {receivedData?.interviewStatus}
                </span>{" "}
              </p>
              <p className="">
                Interview Type:{" "}
                <span className="text-secondary fw-normal">
                  {receivedData?.inteviewType === "TECHNICAL" ? receivedData?.inteviewType.charAt(0).toUpperCase() +
                    receivedData?.inteviewType.slice(1).toLowerCase() : receivedData?.inteviewType}
                </span>{" "}
              </p>
              {!location.pathname.includes('/admin/interview/interviews_info') && receivedData?.interviewStatus === "SCHEDULED" && isJoinButtonEnabled() && <p className="">
                Interview Link:{" "}
                <span>
                  <a className="linkStyling2" href={receivedData?.interviewLink} target="_blank">{receivedData?.interviewLink}</a>
                </span>{" "}
              </p>}
              {!location.pathname.includes('/admin/interview/interviews_info') && receivedData?.resumeFileUrl && <p className="">
                Resume:{" "}
                <a
                  target="_blank"
                  href={receivedData?.resumeFileUrl}
                  className="linkStyling2 fw-normal"
                >
                  Click Here
                </a>{" "}
              </p>
              }
              {receivedData?.remark && (!candidateIdData || userIdData == receivedData?.interviewerId) && (
                <p className="">
                  Feedback:{" "}
                  <span className="text-secondary fw-normal">
                    {receivedData?.remark}
                  </span>{" "}
                </p>
              )}

              {receivedData?.rating && (!candidateIdData || userIdData == receivedData?.interviewerId) && (
                <p className="">
                  Score:{" "}
                  <span className="text-secondary fw-normal">
                    {receivedData?.rating}
                  </span>{" "}
                </p>
              )}

              {!location.pathname.includes('/admin/interview/interviews_info') && receivedData?.jobAttachmentFile && (
                <p className="">
                  {/* Assignment:{" "} */}
                  <a href={receivedData?.jobAttachmentFile} target="_blank">
                    <button
                      type="button"
                      style={{ width: "170px" }}
                      class="btn .btn-outline-primary-custom"
                    >
                      View Assignment
                    </button>
                  </a>
                </p>
              )}

              <p>
                Interview Mode:{" "}
                <span className="text-secondary fw-normal">
                  {receivedData?.interviewMode}
                </span>
              </p>

              {
                <p>
                  Round:{" "}
                  <span className="text-secondary fw-normal">
                    {receivedData?.round}
                  </span>
                </p>

              }

              <p className="">
                Candidate Name:{" "}
                <span className="text-secondary fw-normal">
                  {receivedData?.candidateName || "N/A"}
                </span>{" "}
              </p>
              <p>
                Job Position:{" "}
                <span className="text-secondary fw-normal">
                  {receivedData?.jobPosition || "N/A"}
                </span>
              </p>
              {/* <p>
                Vendor Name:{" "}
                <span className="text-secondary fw-normal">
                  {receivedData?.vendorName || "N/A"}
                </span>
              </p> */}

              {/* Feedback and Join Buttons */}
              {receivedData?.candidateInterviewStatus !== "PENDING" && !candidateIdData &&
                <p>
                  Interviwer Feedback:{" "}
                  <span style={{
                    color:
                      receivedData?.candidateInterviewStatus === "REJECT"
                        ? "red"
                        : receivedData?.candidateInterviewStatus === "SELECT"
                          ? "#03d003"
                          : receivedData?.candidateInterviewStatus === "PENDING"
                            ? "yellow"
                            : "orange",
                    padding: "5px 15px",
                    // color: "white"
                  }} className=" fw-">
                    {receivedData?.candidateInterviewStatus || "N/A"}
                  </span>
                </p>
              }
              {receivedData?.interviewStatus !== "CANCELLED" && userIdData == receivedData?.interviewerId && <div>
                {receivedData?.isInterviewClosed ? <Feedback recieve={receivedData} reload={reload} interviewId={receivedData?.interviewId} feedData={receivedData?.remark} setReload={setReload} disable={!isFeedbackButtonEnabled()} /> :
                  <Button className="btn-primary-custom" disabled={!isFeedbackButtonEnabled()} onClick={() => setIsComplete(true)}>
                    {"Over Interview"}
                  </Button>
                }
              </div>}
              {!location.pathname.includes('admin') && (!receivedData?.isInterviewClosed && receivedData?.interviewStatus !== "COMPLETED" && receivedData?.interviewStatus !== "CANCELLED" &&
                <div>
                  <Button
                    className="btn-primary-custom"
                    disabled={!isJoinButtonEnabled() || location.pathname.includes('admin')}
                    href={receivedData?.interviewLink}
                    target="_blank"
                  >
                    <span style={{ color: 'white' }}> Join </span>
                  </Button>
                </div>)
              }
            </div>
            {
              !location.pathname.includes('admin') &&
              receivedData?.interviewStatus !== "COMPLETED" && receivedData?.interviewStatus !== "CANCELLED" &&
              <div style={{ padding: 10, color: 'rgb(234 179 8)', fontSize: '15px' }}> <i> Note :-  <span>  &nbsp; </span> <span>
                The Join button will be enabled 10 minutes before the interview time
              </span>
                {userIdData == receivedData?.interviewerId && <span> & Feedback button will be enabled after 5 minutes of interview time</span>}
              </i></div>

            }
          </div>
        </div>
        {location.pathname === '/admin/interview/interviews_info' && <div>
          {<div style={{ padding:"1.5rem"}} className="vj_wrapper">
            <div style={{ boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.1)" }}>
              <p className="common_table_header" style={{ margin: "0px" }}>Resource Hiring Details</p>
              <div className="line_divide"></div>
              {
                Object.keys(interviewerVendor ?? {})?.length > 0 ?
                  <div style={{ padding: 20, backgroundColor: 'white' }}>
                    <div style={{ display: 'flex', gap: '30px', flexWrap: 'wrap', width: '100%' }}>
                      <div style={{ height: '12rem', width: '12rem', borderRadius: 10, padding: 3 }}>
                        <img style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: 10 }}
                          src={interviewerVendor?.vendorProfileImageUrl ?? 'https://w7.pngwing.com/pngs/910/606/png-transparent-head-the-dummy-avatar-man-tie-jacket-user-thumbnail.png'}
                          alt='' />
                      </div>

                      <table style={{ flex: 1 }}>
                        <tbody
                          style={{
                            display: 'grid',
                            gridTemplateColumns: width > 500 ? 'repeat(auto-fit, minmax(350px, 1fr))' : 'repeat(auto-fit, minmax(250px, 1fr))',
                            gap: 10,
                            wordBreak: 'break-word'
                          }}
                        >
                          {[
                            { label: "Vendor Id", value: interviewerVendor?.vendorEmpId },
                            { label: "Vendor Name", value: `${interviewerVendor?.firstName ?? 'N/A'} ${interviewerVendor?.lastName ?? ''}` },
                            { label: "Phone", value: `+${interviewerVendor?.dialCode} ${interviewerVendor?.mobile ?? 'N/A'}` },
                            { label: "Email", value: interviewerVendor?.email ?? 'N/A' },
                            { label: "Company Name", value: interviewerVendor?.company ?? 'N/A' },
                            {
                              label: "Company Website",
                              value: interviewerVendor?.companyWebsite ? (
                                <a href={interviewerVendor?.companyWebsite} target='_blank' rel="noopener noreferrer">
                                  {interviewerVendor?.companyWebsite}
                                </a>
                              ) : 'N/A'
                            },
                            {
                              label: "Location",
                              value: interviewerVendor?.address || interviewerVendor?.city || interviewerVendor?.country
                                ? `${interviewerVendor?.address || ''} ${interviewerVendor?.city || ''} ${interviewerVendor?.country || ''}`
                                  .trim()
                                  .split(' ')
                                  .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                                  .join(' ')
                                : 'N/A'
                            },
                            {
                              label: "Company Logo",
                              value: interviewerVendor?.companyLogoUrl ? (
                                <a href={interviewerVendor?.companyLogoUrl} target='_blank' rel="noopener noreferrer">
                                  Link
                                </a>
                              ) : 'N/A'
                            }
                          ].map((item, index) => (
                            <tr key={index} style={{ display: 'flex', flexDirection: 'row', gap: 6 }}>
                              <th style={{ width: '35%', fontWeight: 500, color: 'rgba(1, 41, 112, 0.6)', fontSize: width > 500 ? '15px' : '12px' }}>
                                {item.label}
                              </th>
                              <td style={{ fontWeight: 300, fontSize: width > 500 ? '15px' : '12px' }}>
                                {item.value}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                    </div>

                  </div> :
                  <div style={{ padding: 20, backgroundColor: 'white' }}>
                    This Candidate have no Resource Provider , It's a Individual Candidates
                  </div>
              }

            </div>



          </div>}

          {candidateVendor && <div style={{ padding:"1.5rem"}} className="vj_wrapper">

            <div style={{ boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.1)" }}>
              <p className="common_table_header" style={{ margin: "0px" }}>Resource Provider Details</p>
              <div className="line_divide"></div>
              {
                Object.keys(candidateVendor ?? {})?.length > 0 ?
                  <div style={{ padding: 20, backgroundColor: 'white' }}>
                    <div style={{ display: 'flex', gap: '30px', flexWrap: 'wrap', width: '100%' }}>
                      <div style={{ height: '12rem', width: '12rem', borderRadius: 10, padding: 3 }}>
                        <img style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: 10 }}
                          src={candidateVendor?.vendorProfileImageUrl ?? 'https://w7.pngwing.com/pngs/910/606/png-transparent-head-the-dummy-avatar-man-tie-jacket-user-thumbnail.png'}
                          alt='' />
                      </div>

                      <table style={{ flex: 1 }}>
                        <tbody
                          style={{
                            display: 'grid',
                            gridTemplateColumns: width > 500 ? 'repeat(auto-fit, minmax(350px, 1fr))' : 'repeat(auto-fit, minmax(250px, 1fr))',
                            gap: 10,
                            wordBreak: 'break-word'
                          }}
                        >
                          {[
                            { label: "Vendor Id", value: candidateVendor?.vendorEmpId },
                            { label: "Vendor Name", value: `${candidateVendor?.firstName ?? 'N/A'} ${candidateVendor?.lastName ?? ''}` },
                            { label: "Phone", value: `+${candidateVendor?.dialCode} ${candidateVendor?.mobile ?? 'N/A'}` },
                            { label: "Email", value: candidateVendor?.email ?? 'N/A' },
                            { label: "Company Name", value: candidateVendor?.company ?? 'N/A' },
                            {
                              label: "Company Website",
                              value: candidateVendor?.companyWebsite ? (
                                <a href={candidateVendor?.companyWebsite} target='_blank' rel="noopener noreferrer">
                                  {candidateVendor?.companyWebsite}
                                </a>
                              ) : 'N/A'
                            },
                            {
                              label: "Location",
                              value: candidateVendor?.address || candidateVendor?.city || candidateVendor?.country
                                ? `${candidateVendor?.address || ''} ${candidateVendor?.city || ''} ${candidateVendor?.country || ''}`
                                  .trim()
                                  .split(' ')
                                  .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                                  .join(' ')
                                : 'N/A'
                            },
                            {
                              label: "Company Logo",
                              value: candidateVendor?.companyLogoUrl ? (
                                <a href={candidateVendor?.companyLogoUrl} target='_blank' rel="noopener noreferrer">
                                  Link
                                </a>
                              ) : 'N/A'
                            }
                          ].map((item, index) => (
                            <tr key={index} style={{ display: 'flex', flexDirection: 'row', gap: 6 }}>
                              <th style={{ width: '35%', fontWeight: 500, color: 'rgba(1, 41, 112, 0.6)', fontSize: width > 500 ? '15px' : '12px' }}>
                                {item.label}
                              </th>
                              <td style={{ fontWeight: 300, fontSize: width > 500 ? '15px' : '12px' }}>
                                {item.value}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                    </div>

                  </div> :
                  <div style={{ padding: 20, backgroundColor: 'white' }}>
                    This Candidate have no Resource Provider , It's a Individual Candidates
                  </div>
              }

            </div>



          </div>}

          {!candidateVendor && <div style={{ padding:"1.5rem"}} className="vj_wrapper">
            <div style={{ boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.1)" }}>
              <div style={{ paddingRight: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: 'white' }}>
                <div className="common_table_header" > Candidate Details </div>
              </div>
              <div className="line_divide"></div>
              <div style={{ padding: 20, backgroundColor: 'white' }}>
                <div style={{ display: 'flex', gap: '30px', flexWrap: 'wrap', width: '100%' }}>
                  <div style={{ height: '12rem', width: '12rem', borderRadius: 10, padding: 3 }}>
                    <img style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: 10 }} src={candidateDetails?.profileImageUrl ?? 'https://w7.pngwing.com/pngs/910/606/png-transparent-head-the-dummy-avatar-man-tie-jacket-user-thumbnail.png'} alt='' />
                  </div>

                  <table style={{ flex: 1 }}>
                    <tbody style={{ display: 'grid', width: '100%', gridTemplateColumns: width > 500 ? 'repeat(auto-fit, minmax(350px, 1fr))' : 'repeat(auto-fit, minmax(250px, 1fr))', gap: 10, wordBreak: 'break-word' }}>
                      {[
                        { label: "Employee Id", value: candidateDetails?.candidateEmpId },
                        { label: "Full Name", value: `${candidateDetails?.firstName} ${candidateDetails?.lastName}` },
                        { label: "Phone", value: `+${candidateDetails?.countryCode} ${candidateDetails?.mobile}` },
                        { label: "Experience", value: candidateDetails?.keyExperience },
                        { label: "Designation", value: candidateDetails?.currentDesignation },
                        { label: "Email", value: candidateDetails?.email },
                        { label: "PAN NO.", value: candidateDetails?.panCardNumber },
                        { label: "AADHAAR NO.", value: candidateDetails?.aadharCardNumber },
                        { label: "Department", value: candidateDetails?.department?.replace(/_/g, ' ') || 'N/A' },
                        { label: "Skills", value: candidateDetails?.skillList?.join(', ') || 'N/A' }
                      ].map((item, index) => (
                        <tr key={index} style={{ display: 'flex', flexDirection: 'row', gap: 6 }}>
                          <th style={{ fontWeight: 500, color: 'rgba(1, 41, 112, 0.6)', width: '35%', wordBreak: 'break-word', fontSize: width > 500 ? '15px' : '12px' }}>
                            {item.label}
                          </th>
                          <td style={{ fontWeight: 300, wordBreak: 'break-word', fontSize: width > 500 ? '15px' : '12px' }}>{item.value}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>}
        </div>}

      </div>

      <Modal
        show={isInterviewComplete}
        onHide={() => setIsComplete(false)}
        backdrop="static"
        keyboard={false}
        style={{ top: "25%" }}
      >
        <Modal.Header >
          <Modal.Title className="w-100 text-center">Over Interview</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center fs-5">
          Are you sure this interview is over?
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <button
            disabled={isComeDis}
            className="btn-lg btn-primary-custom"
            onClick={handleCompleteInterview}
          >
            {isComeDis ? "Loading..." : "Yes"}
          </button>
          <Button variant="secondary" className="btn-lg" onClick={() => setIsComplete(false)}>
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AssignedInterviewsInfo;
